import { lazyLoad } from 'utils/loadable';

export const BasicInfoPage = lazyLoad(
  () => import('./index'),
  module => module.BasicInfoPage,
);
